import React, { useRef } from 'react';
import {
  SiteNav, HomeFooter, MobileAktionsleiste,
  useReveal, useScrollNav, useScrollToHashOnMount, useStartAnfrage,
} from './shared';
import Seo from './Seo';
import HeroLeadForm from './HeroLeadForm';
import {
  HomeHero, Mandate, Stakes, CaseStudies, Testimonials, Approach,
  Benefits, Platform, Process, Expert, FAQ, FinalCTA,
} from './sections';
import { MietpreisAnalyseTool } from './tools/MietpreisAnalysePage';

/**
 * Startseite.
 *
 * Die Reihenfolge folgt der Frage, die der Besucher an dieser Stelle hat:
 *
 *   Aufmacher   Was tun die, fuer wen, und koennen die das?  (Beleg sofort)
 *   Analyse     Etwas, das sofort nuetzt — und dieselben Angaben einsammelt
 *   Mandat      Was passiert, wenn ich mich melde?           (Antwort aufs Formular)
 *   Kennen Sie  Erkenne ich mich darin wieder?               (nach dem Beleg, nicht davor —
 *               kaltem Verkehr von Meta und Erben gibt es hier die Sprache fuer ihr Problem)
 *   Fallstudien Stimmt das auch im Detail?
 *   Methode     Wie arbeiten die?
 *   Technologie Womit?
 *   Vorteile    Was aendert sich fuer mich?
 *   Prozess     Wie laeuft das ab?
 *   Ueber uns   Wer macht das?
 *   Fragen      Was ist noch offen?
 *   Anfrage     Also gut.
 *
 * `numbered-sections` nummeriert jedes `.section-label.numbered` in DOM-Reihen-
 * folge — die Ziffern folgen also jeder Umstellung von selbst.
 */

export default function HomePage() {
  useReveal();
  useScrollNav();
  useScrollToHashOnMount();
  const formRef = useRef(null);

  const startFunnel = useStartAnfrage();

  return (
    <div className="page-enter numbered-sections" data-screen-label="01 Home">
      <Seo
        path="/"
        title="hamba — Private Immobilienverwaltung im Rhein-Main-Gebiet"
        description="Wir übernehmen die komplette Verwaltung Ihrer Mehrfamilienhäuser und Portfolios im Rhein-Main-Gebiet: Mieten auf Marktniveau, Rückstände eingetrieben, ein verantwortlicher Ansprechpartner."
      />
      <SiteNav />

      <HomeHero />

      {/* Das Werkzeug von /kostenlose-mietpreis-analyse, hier eingesetzt: Wer
          nicht telefonieren und kein Formular ausfuellen will, bekommt direkt
          unter dem Aufmacher etwas, das ihm sofort nuetzt — und hinterlaesst
          dabei dieselben Angaben. Es ist dieselbe Komponente, nicht eine
          Kopie; Aenderungen am Fragebogen gelten hier wie dort. */}
      <MietpreisAnalyseTool eingebettet />

      <Mandate onCTA={startFunnel} />
      <Stakes />
      <CaseStudies />
      <Approach />
      <Platform />
      <Benefits />
      <Process />
      <Expert />
      <FAQ />
      <Testimonials />

      <div id="anfrage">
        <FinalCTA onStartFunnel={startFunnel} formRef={formRef} />
        <section className="home-abschluss">
          <div className="shell">
            <HeroLeadForm />
          </div>
        </section>
      </div>

      <HomeFooter />

      {/* Muss direktes Kind von .page-enter bleiben — homev2.css haelt darueber
          den Fussbereich frei. */}
      <MobileAktionsleiste onAnfrage={startFunnel} />
    </div>
  );
}
